// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__uFrKr","info":"Note_info__30nLd","note":"Note_note__2-6HX","actions":"Note_actions__2EVmg"};